import React from 'react';
// import Control from './Control';
// import ToolTips from './ToolTips';
import Places from './Places';
// import testSession from '../helpers/testSession';

const Scheme = props => {
  if (props.loading) {
    return (
      <div className="scheme-popup__scheme scheme-box is-loading">
        Загружаем лучшие места...
      </div>
    );
  }

  return (
    <React.Fragment>
      <Places
        session={props.session}
        selected={props.selected}
        onSelect={id => props.onSelect(id)}
        amount={props.amount}
        checkout={props.checkout}
        nextStepAfterSchema={props.nextStepAfterSchema}
      />
      {/*
        width={props.session.width}
        height={props.session.height}
        age={props.session.age}
        datetime={props.session.datetime}
        places={props.session.places}
        selected={props.selected}
        exit={props.session.enters}
        disabled={props.session.disabled}
      */}
    </React.Fragment>
  );
};

export default Scheme;
